(function(angular){
	'use strict';
	
	angular
		.module('formValidationModule')
		.directive('valueMatches', [
			'$parse',
			valueMatchesFunction
		]);
	
	function valueMatchesFunction($parse) {
		return {
			require: 'ngModel',
			restrict: 'A',
			link: function(scope, elm, attrs, ngModel) {
				var originalModel = $parse(attrs.valueMatches);
				var secondModel = $parse(attrs.ngModel);
				
				scope.$watch(attrs.ngModel, function (newValue) {
					ngModel.$setValidity('valueMatches', newValue === originalModel(scope));
				});

				scope.$watch(attrs.valueMatches, function (newValue) {
					ngModel.$setValidity('valueMatches', newValue === secondModel(scope));
				});
			}
		};
	}
})(window.angular);